import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import { fetchPortalAccess } from '../services/recharge';
import { navigateToRechargePaymentPortal } from '../utils/helper';
import notification from '../utils/notification';

const AddPaymentMethodPromptModal = ({ isOpen, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleAddPaymentMethod = async () => {
    setIsLoading(true);
    try {
      await navigateToRechargePaymentPortal(fetchPortalAccess);
      // Close the modal after opening the portal in a new tab
      onClose();
    } catch (error) {
      console.error('Error navigating to payment portal:', error);
      notification.error('Unable to access payment portal. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      name="add-payment-method-prompt"
      isOpen={isOpen}
      onClose={onClose}
      title="Add Payment Method"
      description="Needed before you can place an order."
      closeOnBackdropClick={false}
    >
      <div className="space-y-4 text-center">
        <p className="text-gray-600 text-sm">
          To place an order, you need to add a payment method to your account.
        </p>

        <p className="text-gray-600 text-sm">
          Click the button below to add your payment information.
        </p>

        <div className="space-y-3">
          <Button
            variant="primary"
            fullWidth
            onClick={handleAddPaymentMethod}
            disabled={isLoading}
          >
            {isLoading ? 'Loading...' : 'Add Payment Method'}
          </Button>

          <Button
            variant="secondary"
            fullWidth
            onClick={onClose}
            disabled={isLoading}
          >
            Remind Me Later
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddPaymentMethodPromptModal;
